import "./Anmelden.css";
import {useEffect, useState} from "react";
import Title from "../components/title/Title";
import BisTextfield from "../components/bisTextfield/BisTextfield";
import BisDialog from "../components/bisDialog/BisDialog";
import PasswortVergessen from "./PwVergessen";
import Registrierung from "./Registrierung";
import {Button} from "@radix-ui/themes";
import BisPasswordfield from "../components/bisPaswordfield/BisPasswordfield";
import log from 'loglevel';

function Anmelden({onPasswordReset}) {

    const [isDialogPwVergessenOpen, setIsDialogPwVergessenOpen] = useState(false);
    const [isDialogRegistrierenOpen, setIsDialogRegistrierenOpen] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [usernameError, setUsernameError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [message, setMessage] = useState('');
    const [isMessageVisible, setIsMessageVisible] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleBtnClickAnmeldung = async () => {

        const formIsValid = validateInput();
        if (!formIsValid) return;

        setIsSubmitting(true);

        try {
            const result = await validateCredentials();

            if (result.passwordResetRequired) {
                onPasswordReset(username, password);
                return;
            }

            if (result.success) {
                toggleMessage(false);
                window.location.href = result.url;
            } else {
                setMessage(result.error);
                toggleMessage(true);
            }

        } catch (error) {
            log.debug("Es ist ein Fehler aufgetreten: " + error.message);
            setMessage('Es ist ein Fehler aufgetreten');
            toggleMessage(true);
        } finally {
            setIsSubmitting(false);
        }
    };

    const validateInput = () => {
        let valid = true;

        if (!username) {
            setUsernameError("Bitte geben Sie Ihren Benutzernamen ein");
            valid = false;
        } else {
            setUsernameError("");
        }

        if (!password) {
            setPasswordError("Bitte geben Sie Ihr Passwort ein");
            valid = false;
        } else {
            setPasswordError("");
        }

        if (!username || !password) {
            toggleMessage(false);
        }

        return valid;
    }

    const validateCredentials = async () => {
        const response = await fetch(`${window.location.origin}/bis-login2/auth`, {
            method: 'POST',
            credentials: "include",
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({username, password}),
        });

        const data = await response.json();

        if (!response.ok) {

            if (data.errorCode === "20000") {
                return {success: false, error: "Benutzername oder Passwort ungültig"};
            }

            if (data.errorCode === "20002") {
                return {success: false, passwordResetRequired: true};
            } else {
                return {success: false, error: 'Es ist ein Fehler aufgetreten'};
            }
        }

        return {success: true, url: data.url};
    }

    const toggleMessage = (shouldShow) => {
        setIsMessageVisible(shouldShow);
    };

    const onZurueckClick = () => {
        if (isDialogPwVergessenOpen) setIsDialogPwVergessenOpen(false);
        if (isDialogRegistrierenOpen) setIsDialogRegistrierenOpen(false);
    }

    const onPasswortVergessenClick = () => setIsDialogPwVergessenOpen(true);
    const onRegistrierenClick = () => setIsDialogRegistrierenOpen(true);

    useEffect(() => {
        if (usernameError) {
            document.getElementById('anmelden-benutzername-field').focus();
        } else if (passwordError) {
            document.getElementById('anmelden-password-field').focus();
        }
    }, [usernameError, passwordError]);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        await handleBtnClickAnmeldung();
    };

    return (
        <form className="anmelden-container" onSubmit={handleFormSubmit}>
            <Title text="Anmeldung"/>

            {isMessageVisible && (
                <div className="invalid-credentials" role="alert" aria-live="assertive">
                    <p>{message}</p>
                </div>
            )}

            <BisTextfield
                id="anmelden-benutzername-field"
                label="Benutzername"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                error={usernameError}
                aria-invalid={usernameError ? "true" : "false"}
                aria-describedby={usernameError ? "benutzername-error" : undefined}
            />

            <BisPasswordfield
                id="anmelden-password-field"
                label="Passwort"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                error={passwordError}
                aria-invalid={passwordError ? "true" : "false"}
                aria-describedby={passwordError ? "password-error" : undefined}
            />

            <Button
                id="btn-anmeldung"
                className="anmelden-btn"
                type="submit"
                disabled={isSubmitting}
                text="Anmelden"
                variant="solid"
                aria-label="Melden Sie sich an"
            >
                {isSubmitting ? "Anmelden..." : "Anmelden"}
            </Button>

            <div className="container-forgotPw-registrate">
                <Button type="button" className="link" variant="ghost" onClick={onPasswortVergessenClick}
                        aria-label="Passwort vergessen">Passwort vergessen?</Button>
                <Button type="button" className="link" variant="ghost" onClick={onRegistrierenClick}
                        aria-label="Registrieren">Registrieren</Button>
            </div>

            <BisDialog
                isOpen={isDialogPwVergessenOpen}
                onClose={() => setIsDialogPwVergessenOpen(false)}
                title="Passwort zurücksetzen"
                description={isDialogPwVergessenOpen ? "" : undefined}
                aria-labelledby="dialog-pw-vergeben"
                aria-describedby="dialog-pw-vergeben-description"
            >
                <PasswortVergessen onZurueckClick={onZurueckClick}/>
            </BisDialog>

            <BisDialog
                isOpen={isDialogRegistrierenOpen}
                onClose={() => setIsDialogRegistrierenOpen(false)}
                title="Registrierung"
                description={isDialogRegistrierenOpen ? "Um Zugang zum Bodenschutzkataster zu erhalten, füllen Sie das verlinkte PDF-Formular aus und senden es unterschrieben per E-Mail an das Landesamt für Umwelt." : undefined}
                aria-labelledby="dialog-registrieren"
                aria-describedby="dialog-registrieren-description"
            >
                <Registrierung onZurueckClick={onZurueckClick}/>
            </BisDialog>
        </form>
    );
}

export default Anmelden;
